import { useNavigate } from 'react-router'
import { Image } from 'antd-mobile'
import type { Order } from '@/types/interfaces'
import { constant, cal } from '@/utils'
import ShippingTypeLabel from "@/components/ShippingTypeLabel"
import useCorpSettingStore from '@/stores/corp-setting'
import OrderStatusLabel from '../OrderStatusLabel'
import styles from './index.module.less'

interface IProps {
  order: Order
  [key: string]: any
}

const { IMAGE_DEFAULT } = constant.product
const DISPLAY_LIMIT = 4

function OrderItem(props: IProps) {
  const { order, ...attrs } = props
  const navigate = useNavigate()
  const { corpSetting } = useCorpSettingStore()
  // subSourceType	子来源类型 0app 1pc 2开个单 3云店定制 4企微单据 5企微开单单据 6国内发货订单 7海外发货订单
  // shippingType 0国内 1海外
  const shippingType = order?.subSourceType === 7 ? 0 : 1

  // 点击单据详情
  function onOrderDetailClick() {
    navigate(`/order/detail/${order.orderId}`)
  }

  return (
    <div { ...attrs } className={ styles["order-item-wrap"] }
      onClick={ onOrderDetailClick }>
      {/*  单据头部 时间与金额  */}
      <div className={ styles["header-box"] }>
        <div className={ styles["info-cell"] }>
          <div className={ styles["order-status"] }>
            {/*  标签  */}
            <OrderStatusLabel
              order={ order }
            />
          </div>
          {/*  单据价格  */}
          <div className={ styles["order-price"] }>
            { corpSetting.currencySymbol }{ cal.moneyFormat(order.receivable) }
          </div>
        </div>

        <div className={ styles["info-cell"] }>
          <div className={ styles["order-num"] }>
            {
              order.orderNum &&
              <span>{ order.orderNum }</span>
            }
          </div>
          <div className={ styles["order-date"] }>{ order.completeStatusTimeLabel }</div>
        </div>
      </div>

      {/*  单据中间 图片与状态  */}
      <div className={ styles["footer-box"] }>
        {/*  图片  */}
        {
          !!order.productImgs?.length &&
          <div className={ styles["img-box"] }>
            {/*  限制三个图片 index < 4 */}
            {
              order.productImgs.map((img: string, imgIdx: number) => (
                <div key={ imgIdx }>
                  {
                    imgIdx < DISPLAY_LIMIT &&
                    <div>
                    <Image
                      lazy
                      className={ styles["product-img"] }
                      src={ img || IMAGE_DEFAULT }/>
                      </div>
                  }
                </div>
              ))/*  */

            }
          </div>
        }
        <ShippingTypeLabel shippingType={ shippingType } />
        {/*  底部备注  */}
        {/* {
          order.remark &&
          <div className={ styles["remark"] }>{ order.remark }</div>
        } */}
      </div>
    </div>
  )
}

export default OrderItem
